// Tools we can build custom integrations with. Logo images are pulled from
// Logo.dev by domain (see src/lib/logoDev.ts). Tool names + domains are
// language-neutral; the surrounding copy (category titles, descriptions) is
// translated via the `integrations.*` i18n keys.

export type IntegrationTool = { name: string; domain: string };
export type IntegrationCategory = { id: string; tools: IntegrationTool[] };

export const integrationCategories: IntegrationCategory[] = [
  {
    id: "communication",
    tools: [
      { name: "Outlook", domain: "outlook.com" },
      { name: "Gmail", domain: "gmail.com" },
      { name: "Slack", domain: "slack.com" },
      { name: "Microsoft Teams", domain: "microsoft.com" },
      { name: "Zendesk", domain: "zendesk.com" },
      { name: "Intercom", domain: "intercom.com" },
      { name: "Freshdesk", domain: "freshdesk.com" },
      { name: "WhatsApp Business", domain: "whatsapp.com" },
      { name: "LinkedIn", domain: "linkedin.com" },
    ],
  },
  {
    id: "sales",
    tools: [
      { name: "HubSpot", domain: "hubspot.com" },
      { name: "Salesforce", domain: "salesforce.com" },
      { name: "Pipedrive", domain: "pipedrive.com" },
      { name: "Zoho", domain: "zoho.com" },
      { name: "monday.com", domain: "monday.com" },
      { name: "Mailchimp", domain: "mailchimp.com" },
      { name: "Klaviyo", domain: "klaviyo.com" },
    ],
  },
  {
    id: "commerce",
    tools: [
      { name: "Shopify", domain: "shopify.com" },
      { name: "WooCommerce", domain: "woocommerce.com" },
      { name: "Stripe", domain: "stripe.com" },
      { name: "PayPal", domain: "paypal.com" },
      { name: "Klarna", domain: "klarna.com" },
      { name: "DATEV", domain: "datev.de" },
      { name: "Lexware", domain: "lexware.de" },
      { name: "QuickBooks", domain: "intuit.com" },
    ],
  },
  {
    id: "productivity",
    tools: [
      { name: "Google Workspace", domain: "google.com" },
      { name: "Microsoft 365", domain: "office.com" },
      { name: "Notion", domain: "notion.so" },
      { name: "Airtable", domain: "airtable.com" },
      { name: "Zapier", domain: "zapier.com" },
      { name: "Make", domain: "make.com" },
      { name: "Asana", domain: "asana.com" },
      { name: "Trello", domain: "trello.com" },
      { name: "Google Calendar", domain: "calendar.google.com" },
      { name: "Calendly", domain: "calendly.com" },
    ],
  },
];

/** A flat, curated set of well-known logos for the homepage teaser marquee. */
export const featuredTools: IntegrationTool[] = [
  { name: "Outlook", domain: "outlook.com" },
  { name: "Slack", domain: "slack.com" },
  { name: "Zendesk", domain: "zendesk.com" },
  { name: "HubSpot", domain: "hubspot.com" },
  { name: "Salesforce", domain: "salesforce.com" },
  { name: "Shopify", domain: "shopify.com" },
  { name: "Stripe", domain: "stripe.com" },
  { name: "PayPal", domain: "paypal.com" },
  { name: "Notion", domain: "notion.so" },
  { name: "Airtable", domain: "airtable.com" },
  { name: "Zapier", domain: "zapier.com" },
  { name: "DATEV", domain: "datev.de" },
  { name: "Microsoft Teams", domain: "microsoft.com" },
  { name: "Google Workspace", domain: "google.com" },
  { name: "Pipedrive", domain: "pipedrive.com" },
  { name: "Intercom", domain: "intercom.com" },
];
